export const clearPlusFromPhoneNumber = (phone: string) => (phone.startsWith('+') ? phone.slice(1) : phone)
